import React, { useEffect, useRef, useState } from "react";
import SideModal from "./SideModal";
import fastag from "../assets/fastaglogo.png";
import { ShoppingBag, Info, Import } from "lucide-react";
import AddBulkicon from "../assets/AddBulkicon.png";
import { MdOutlineFileUpload } from "react-icons/md";
import { ErrorToast, SuccessToast } from "../Utils/toast";
import { API } from "../Common/Api";
import { validateMobile, handleMobileChange, isMobileValidForSubmission, validateMobileComplete, getMobileInputProps } from "../Utils/mobileValidation";
import moment from "moment/moment";
import { getVehicleClassData } from "../Utils/helper";
import { useDispatch, useSelector } from "react-redux";
import { ACTIONS } from "../redux/actions";
import { set } from "date-fns";
import CustomSelectInput from "./SelectInput";
import SearchableSelectInput from "./SearchableSelectInput";
import { useLocation } from "react-router-dom";

// AgentDetails 
export const AgentDetails = ({ agent, onBack, title = "Agent Details", modalItem }) => {
  const [modalOpen, setModalOpen] = useState(true);

  const handleClose = () => {
    setModalOpen(false);
    if (onBack) onBack(); // Call back function if provided
  };

  const location = useLocation();
  return (
    <>
      {modalOpen && (
        <SideModal title={title} image={AddBulkicon} onClose={handleClose} setModalOpen={setModalOpen}>
          <div className="max-w-md text-[14px] mt-[26px] space-y-4">
            {!!(agent?.Name || agent?.username) && (
              <div className="grid grid-cols-2 gap-y-4 gap-x-4">
                <p className="text-gray-400 text-sm">Name</p>
                <p className="font-medium">{agent.username || agent.name}</p>
              </div>
            )}
            {!!(agent.mobile || agent.mobileNo) && (
              <div className="grid grid-cols-2 gap-y-4 gap-x-4">
                <p className="text-gray-400 text-sm">Mobile Number</p>
                <p className="font-medium">{agent.mobile || agent.mobileNo}</p>
              </div>
            )}

            {!!(modalItem?.tagRefId) && (
              <div className="grid grid-cols-2 gap-y-4 gap-x-4">
                <p className="text-gray-400 text-sm">Tag Ref ID</p>
                <p className="font-medium">{modalItem?.tagRefId}</p>
              </div>
            )}

            {/* {!!(modalItem?.createdAt) && (
              <div className="grid grid-cols-2 gap-y-4 gap-x-4">
                <p className="text-gray-400 text-sm">Activated Date</p>
                <p className="font-medium"> {moment(agent.createdAt).format("DD MMMM, YYYY")}</p>
              </div>
            )} */}
            {!!(modalItem?.createdAt || modalItem?.userMobileNumber) && (
              <>
                <div className="grid grid-cols-2 gap-y-4 gap-x-4">
                  <p className="text-gray-400 text-sm">Mobile Number</p>
                  <p className="font-medium">{modalItem?.userMobileNumber || "N/A"}</p>
                </div>
                <div className="grid grid-cols-2 gap-y-4 gap-x-4">
                  <p className="text-gray-400 text-sm">Activated Date</p>
                  <p className="font-medium">
                    {modalItem?.userActivationDate
                      ? moment(modalItem.userActivationDate).format("DD MMMM, YYYY, hh:mm A")
                      : "N/A"}
                  </p>
                </div>
              </>
            )}

            {!!(agent?.email) && (
              <div className="grid grid-cols-2 gap-y-4 gap-x-4">
                <p className="text-gray-400 text-sm">Email Address</p>
                <p className="font-medium">{agent.email}</p>
              </div>
            )}

            {agent?.role === "distributor" && (
              <>
                <div className="grid grid-cols-2 gap-y-4 gap-x-4">
                  <p className="text-gray-400 text-sm">Onboarding Date</p>
                  <p className="font-medium">
                    {agent?.createdAt ? moment(agent.createdAt).format("DD MMMM, YYYY, hh:mm A") : "N/A"}
                  </p>
                </div>
                <div className="grid grid-cols-2 gap-y-4 gap-x-4">
                  <p className="text-gray-400 text-sm">Created By</p>
                  <p className="font-medium">{agent.createdByAdminName || "N/A"}</p>
                </div>
              </>
            )}

            {location.pathname === "/distributoradmin" && (
              <div className="grid grid-cols-2 gap-y-4 gap-x-4">
                <p className="text-gray-400 text-sm">Status</p>
                <p className={`font-medium ${agent?.isActive ? "text-green-600" : "text-yellow-500"}`}>
                  {agent?.isActive ? "Active" : "Deactive"}
                </p>
              </div>
            )}

            {modalItem?.vehicleClass && (() => {
              const vehicleClassData = getVehicleClassData(modalItem.vehicleClass);

              return (
                <div className="grid grid-cols-2 gap-y-4 gap-x-4">
                  <p className="text-gray-400 text-sm">Vehicle Class</p>
                  <div className="flex flex-row gap-1">
                    <img
                      src={vehicleClassData?.tagimage}
                      alt="Tag"
                      className="w-[34px] h-auto"
                    />  &nbsp;
                    <p className="text-sm text-gray-700">
                      {vehicleClassData?.value || "N/A"}
                    </p>
                  </div>
                </div>
              );
            })()}

            {["/agents", "/inventory"].includes(location.pathname) && (
              <div className="grid grid-cols-2 gap-y-4 gap-x-4">
                <p className="text-gray-400 text-sm">Status</p>
                <p className="font-medium text-green-600">
                  {modalItem?.agentStatus || "Active"}
                </p>
              </div>
            )}

            {["/agent-inventory", "/fastag-activation"].includes(location.pathname) && (
              <div className="grid grid-cols-2 gap-y-4 gap-x-4">
                <p className="text-gray-400 text-sm">Status</p>
                <p className={`font-medium ${modalItem?.isActivated ? "text-green-600" : "text-yellow-500"}`}>
                  {modalItem?.isActivated ? "Assigned" : "Available"}
                </p>
              </div>
            )}

            {!!(agent?.assignedFastag || agent?.assigned || agent?.activatedFastag || agent?.activated) && (
              <>
                <div className="grid grid-cols-2 gap-y-4 gap-x-4">
                  <p className="text-gray-400 text-sm">Assigned FASTag</p>
                  <p className="font-medium">{agent.assignedFastag || agent.assigned || 0}</p>
                </div>
                <div className="grid grid-cols-2 gap-y-4 gap-x-4">
                  <p className="text-gray-400 text-sm">Activated FASTag</p>
                  <p className="font-medium">{agent.activatedFastag || agent.activated || 0}</p>
                </div>
              </>
            )}
          </div>
        </SideModal>
      )}
    </>
  );
};

const AddAgent = ({ onClose, modalOpen, setModalOpen, api = "CreateAgent", title = "Add Agent" }) => {
  const isDistributorFlow = api === "CreateDistributor";
  const fileInputRef = useRef(null);
  const dispatch = useDispatch();
  const GetState = useSelector((state) => state?.GetState);
  const GetCity = useSelector((state) => state?.GetCity);
  const [checkStatesName, setCheckStateName] = useState(false);
  const [checkCitiesName, setCheckCitiesName] = useState(false);
  const [statesList, setStatesList] = useState([]);
  const [citiesList, setCitiesList] = useState([]);


  // const [modalOpen, setModalOpen] = useState(true);
  const [uploadStatus, setUploadStatus] = useState("idle"); // idle | uploading | success
  const [showDetails, setShowDetails] = useState(false);
  const [submittedData, setSubmittedData] = useState(null);
  const isPDF = (file) => file.name.toLowerCase().endsWith('.pdf');
  const [selectedAgent, setSelectedAgent] = useState('');
  const [selectedState, setSelectedState] = useState('');
  const [selectedStateId, setSelectedStateId] = useState('');
  const [selectedCity, setSelectedCity] = useState('');
  // FASTag Activation permission at onboarding time (only for dealer/distributor; agents always activate).
  // const [allowActivation, setAllowActivation] = useState(true);
  // const showActivationOption = isDistributorFlow || api === "CreateDealer";
  // View Transactions permission at onboarding time (agent, dealer & distributor).
  const [allowTransactions, setAllowTransactions] = useState(true);
  const roleLabel = isDistributorFlow ? "distributor" : api === "CreateDealer" ? "dealer" : "agent";







  useEffect(() => {
    setCheckStateName(true)
    dispatch(ACTIONS.GetStateAction());
  }, [])


  useEffect(() => {
    if (checkStatesName) {

      if (GetState?.GetStateData?.status == 200 && GetState?.GetStateData?.success) {
        const statesData = GetState?.GetStateData?.data || [];


        const uniqueState = Array.from(
          new Map(
            statesData?.map((state) => [state.state, state])
          ).values()
        );


        setStatesList(uniqueState);
      } else {

        if (GetState?.GetStateData?.message) {
          ErrorToast(GetState?.GetStateData?.message);
        }
      }
      setCheckStateName(false)
    }
  }, [GetState])

  useEffect(() => {
    if (checkCitiesName) {

      if (GetCity?.GetCityData?.status == 200 && GetCity?.GetCityData?.success) {
        const citiesData = GetCity?.GetCityData?.data || [];

        setCitiesList(citiesData);
      } else {

        if (GetCity?.GetCityData?.message) {
          ErrorToast(GetCity?.GetCityData?.message);
        }
      }
      setCheckCitiesName(false)
    }
  }, [GetCity])

  const [form, setForm] = useState({
    name: "",
    mobile: "",
    email: "",
    state: "",
    city: "",
    pincode: "",
    address: "",
  });

  const [mobileError, setMobileError] = useState("");

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleStateChange = (e) => {
    const stateValue = e.target.value;
    const selectedStateData = statesList.find(state => state.state === stateValue);

    setSelectedState(stateValue);
    setSelectedStateId(selectedStateData?._id || '');
    setForm({ ...form, state: stateValue, city: "" }); // Reset city when state changes
    setSelectedCity('');
    setCitiesList([]); // Clear cities list

    // Fetch cities for the selected state
    if (selectedStateData?._id) {
      setCheckCitiesName(true);
      dispatch(ACTIONS.GetCityAction(selectedStateData._id));
    }
  };

  const handleCityChange = (e) => {
    const cityValue = e.target.value;
    setSelectedCity(cityValue);
    setForm({ ...form, city: cityValue });
  };

  const handleClose = (e) => {
    setModalOpen(false);
    onClose(e);
  };

  const handleDownload = (type) => {
    const url =
      type === "header"
        ? "/downloads/header-only.csv"
        : "/downloads/sample-header.csv";
    const link = document.createElement("a");
    link.href = url;
    link.download = url.split("/").pop();
    link.click();
  };

  const simulateUpload = (file) => {
    setUploadStatus("uploading");

    // Simulate upload delay
    setTimeout(() => {

      setUploadStatus("success");
    }, 1500);
  };


  const UploadFile = async (file) => {
    if (file.type === "application/pdf") {
      setUploadStatus("uploading");
      const formData = new FormData();
      formData.append("file", file);
      const response = await API.UploadFile(formData);

      if (response.status === 200) {
        // Handle success

        setForm({ ...form, kycFile: file, kycFileUrl: response.data });
        SuccessToast(response.message);
      } else {
        // Handle error
        setForm({ ...form, kycFile: '', kycFileUrl: null });

        ErrorToast(response.message);
      }
      setUploadStatus("success");
    } else {
      setUploadStatus("idle");
      setForm({ ...form, kycFile: '', kycFileUrl: null });
      alert("Only PDF files are allowed.");
    }


  }

  const handleFileSelect = async (event) => {
    const file = event.target.files[0];
    if (file) {
      UploadFile(file);
    }
  };

  const handleDrop = (e) => {
    e.preventDefault();
    const file = e.dataTransfer.files[0];
    if (file) {
      UploadFile(file);
    }
  };

  const handleDragOver = (e) => {
    e.preventDefault();
  };

  const handleSubmit = async () => {


    // Validate required fields (KYC details are optional for agents, not required for distributors)
    const missingFields = [];
    if (!form.name) missingFields.push('Name');
    if (!form.mobile) missingFields.push('Mobile Number');
    if (!isDistributorFlow && !form.state) missingFields.push('State');
    if (!isDistributorFlow && !form.city) missingFields.push('City');
    if (!isDistributorFlow && !form.pincode) missingFields.push('Pincode');

    if (missingFields.length > 0) {
      ErrorToast(`Please fill required fields: ${missingFields.join(', ')}`);
      return;
    }

    // Simple mobile validation - must be exactly 10 digits
    if (!/^\d{10}$/.test(form.mobile)) {
      ErrorToast('Mobile number must be exactly 10 digits');
      return;
    }

    // Validate pincode format (only for agents)
    if (!isDistributorFlow && form.pincode.length !== 6) {
      ErrorToast('Pincode must be 6 digits');
      return;
    }

    // Prepare data object with optional KYC fields
    const data = {
      "username": form.name,
      "mobileNo": form.mobile,
    };

    // Add state, city, pincode, and address only for agents
    if (!isDistributorFlow) {
      data.state = form.state;
      data.city = form.city;
      data.pinCode = form.pincode;
      if (form.address && form.address.trim() !== '') {
        data.address = form.address;
      }
    }

    // Add email if provided (optional for distributors, dealers, and agents)
    if (form.email && form.email.trim() !== '') {
      const trimmedEmail = form.email.trim();
      if (!/^\S+@\S+\.\S+$/.test(trimmedEmail)) {
        ErrorToast('Please enter a valid email address');
        return;
      }
      data.email = trimmedEmail.toLowerCase();
    }

    // FASTag Activation permission — only for dealer/distributor (agents always activate).
    // if (showActivationOption) {
    //   data.canActivateFastag = allowActivation;
    // }
    // View Transactions permission — for agent, dealer & distributor.
    data.canViewTransactions = allowTransactions;



    try {
      const response = await API[api](JSON.stringify(data));


      if (response.status === 201 && response.success) {
        SuccessToast(response.message);
        dispatch({ type: "REFRESH_DATA" });

        setSubmittedData({
          ...form,
          onboardingDate: moment(response.data?.createdAt).format('DD MMMM, YYYY, hh:mm A'),
          assignedFastag: 0,
          activatedFastag: 0,
        });
        setForm({
          name: "",
          mobile: "",
          email: "",
          state: "",
          city: "",
          pincode: "",
          address: "",
        });
        setSelectedState('');
        setSelectedCity('');
        setStatesList([]);
        setCitiesList([]);
        // setAllowActivation(true);
        setAllowTransactions(true);
        setUploadStatus("idle");
        setModalOpen(false);
        onClose();
      } else {

        ErrorToast(response.message || 'Failed to create agent');
      }
    } catch (error) {
      console.error('API Call Error:', error);
      ErrorToast('Failed to create agent. Please try again.');
    }

  };

  const uploadClass =
    uploadStatus === "success"
      ? "border-green-500 text-green-600"
      : uploadStatus === "uploading"
        ? "border-yellow-400 text-yellow-600"
        : "border-gray-300 text-gray-600";

  return (
    <div>
      {/* ✅ Show AgentDetails if submitted */}
      {showDetails && submittedData && (
        <AgentDetails agent={submittedData} onBack={() => setShowDetails(false)} />
      )}
      {modalOpen && (
        <SideModal
          title={title}
          image={AddBulkicon}
          onClose={handleClose}
          setModalOpen={setModalOpen}
        >
          <div className="">
            {/* Form Fields */}
            <div className="flex flex-col gap-3">
              <label className="text-sm">Name</label>
              <input
                type="text"
                name="name"
                value={form.name}
                onChange={handleChange}
                placeholder="Enter here"
                className="border border-gray-300 rounded-md px-3 py-2"
              />

              <label className="text-sm">Mobile Number</label>
              <div className="flex items-center border border-[#BEBEBE] rounded-md px-3 py-2">
                <span className="text-gray-500 pr-2">+91</span>
                <input
                  type="tel"
                  value={form.mobile}
                  maxLength={10}
                  inputMode="numeric"
                  placeholder="Enter mobile number"
                  className="outline-none flex-1 appearance-none"
                  onChange={(e) => {
                    const cleaned = e.target.value.replace(/[^0-9]/g, '').substring(0, 10);
                    setForm({ ...form, mobile: cleaned });
                    if (cleaned.length > 0 && cleaned.length < 10) {
                      setMobileError('Mobile number must be exactly 10 digits');
                    } else {
                      setMobileError('');
                    }
                  }}
                />
              </div>
              {mobileError && (
                <p className="text-red-500 text-xs mt-1">{mobileError}</p>
              )}

              {/* Email field - distributors, dealers, and agents (set at creation time) */}
              <label className="text-sm">Email Address (Optional)</label>
              <input
                type="email"
                name="email"
                value={form.email}
                onChange={handleChange}
                placeholder="Enter email address"
                className="border border-gray-300 rounded-md px-3 py-2"
              />

              {/* State and City fields - only show for non-distributors */}
              {!isDistributorFlow && (
                <>
                  <label className="text-sm">Address</label>
                  <textarea
                    name="address"
                    value={form.address}
                    onChange={handleChange}
                    placeholder="Enter Address"
                    className="border border-gray-300 rounded-md px-3 py-2 min-h-[80px] resize-none"
                    rows={3}
                  />

                  <SearchableSelectInput
                    name="selectedState"
                    label="Select State"
                    value={selectedState}
                    onChange={handleStateChange}
                    options={[
                      { name: "Select State", value: "" },
                      ...statesList.map((state) => ({ name: state.state, value: state.state })),
                    ]}
                    inputClass="py-[12.5px] px-3 text-sm text-gray-500"
                    placeholder="Search states..."
                  />

                  <SearchableSelectInput
                    name="selectedCity"
                    label="Select City"
                    value={selectedCity}
                    onChange={handleCityChange}
                    disabled={!selectedState}
                    options={[
                      { name: "Select City", value: "" },
                      ...citiesList.map((city, index) => ({ name: city.city, value: city.city })),
                    ]}
                    inputClass={`py-[12.5px] px-3 text-sm ${selectedState ? "text-gray-500" : "text-gray-400 bg-gray-100 cursor-not-allowed"
                      }`}
                    placeholder="Search cities..."
                  />
                </>
              )}

              {/* Pincode and Address fields - only show for agents */}
              {!isDistributorFlow && (
                <>
                  <label className="text-sm">Pincode</label>
                  <input
                    type="text"
                    name="pincode"
                    value={form.pincode}
                    onChange={handleChange}
                    placeholder="Enter Pincode"
                    className="border border-gray-300 rounded-md px-3 py-2"
                    maxLength={6}
                  />

                  {/* Address Field */}
                </>
              )}

              {/*
              FASTag Activation permission — dealer/distributor onboarding only
              {showActivationOption && (
                <div className="flex items-center justify-between border border-gray-200 rounded-md px-3 py-3 mt-1">
                  <div>
                    <p className="text-sm font-medium text-gray-800">Activate FASTags</p>
                    <p className="text-xs text-gray-500">Allow this {roleLabel} to activate FASTags</p>
                  </div>
                  <button
                    type="button"
                    role="switch"
                    aria-checked={allowActivation}
                    onClick={() => setAllowActivation((v) => !v)}
                    className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors ${allowActivation ? 'bg-green-500' : 'bg-gray-300'}`}
                  >
                    <span
                      className={`inline-block h-5 w-5 transform rounded-full bg-white shadow transition-transform ${allowActivation ? 'translate-x-5' : 'translate-x-1'}`}
                    />
                  </button>
                </div>
              )}
              */}

              {/* View Transactions permission — agent, dealer & distributor onboarding */}
              <div className="flex items-center justify-between border border-gray-200 rounded-md px-3 py-3 mt-1">
                <div>
                  <p className="text-sm font-medium text-gray-800">View Transactions</p>
                  <p className="text-xs text-gray-500">Allow this {roleLabel} to view activated FASTag transactions</p>
                </div>
                <button
                  type="button"
                  role="switch"
                  aria-checked={allowTransactions}
                  onClick={() => setAllowTransactions((v) => !v)}
                  className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors ${allowTransactions ? 'bg-green-500' : 'bg-gray-300'}`}
                >
                  <span
                    className={`inline-block h-5 w-5 transform rounded-full bg-white shadow transition-transform ${allowTransactions ? 'translate-x-5' : 'translate-x-1'}`}
                  />
                </button>
              </div>

              {/* Submit */}
              <button
                onClick={handleSubmit}
                className="bg-[#FEF5F4] text-red-600 border border-red-400 rounded-full py-2 mt-2"
              >
                Submit
              </button>

              {/* Footer Logo */}
              <img
                src={fastag}
                alt="FASTag Logo"
                className="mx-auto mt-4 w-36"
              />
            </div>
          </div>
        </SideModal>
      )}

    </div>
  );
};

export default AddAgent;
